'use strict';

var CalibrationAnalysisPanelConfig = function CalibrationAnalysisPanelConfig($stateProvider) {
  $stateProvider.state('app.calibration-analysis', {
    url: '/workflow/calibration-analysis',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-calibration-analysis-panel></rm-calibration-analysis-panel>'
      }
    }
  });
};
module.exports = CalibrationAnalysisPanelConfig;
CalibrationAnalysisPanelConfig.$inject = ['$stateProvider'];